import React from 'react';
import FullWidth from 'components/page-layouts/full-width';
import Gateway from 'components/page-layouts/gateway';
import PropTypes from 'prop-types';

const PageLayout = props => {
  const { pageLayout } = props;
  const layouts = {
    'Full Width': FullWidth,
    Gateway: Gateway,
  };

  const Layout = layouts[pageLayout] || FullWidth;

  return <Layout {...props} />;
};

PageLayout.propTypes = {
  pageLayout: PropTypes.string,
};
export default PageLayout;
